import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BreadcrumbModule, ModalModule, TableModule, EmptyStateModule, PaginatorModule } from '@michelin/theme';
import { PacklistsComponent } from './components/packlists/packlists.component';
import { SharedModule } from '../../shared/shared.module';
import { CustomerSelectModelComponent } from '../../shared/components/customer-select-model/customer-select-model.component';
import { PacklistDetailsComponent } from './components/packlist-details/packlist-details.component';

@NgModule({
  declarations: [PacklistsComponent, PacklistDetailsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    BreadcrumbModule,
    ModalModule,
    TableModule,
    PaginatorModule,
    EmptyStateModule,
    SharedModule,
    CustomerSelectModelComponent
  ],
  exports: [PacklistsComponent, PacklistDetailsComponent]
})
export class PacklistsModule {}
